import React from "react";
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
import moment from "moment";
import { MDBInput } from "mdb-react-ui-kit";
import "./style.css";
import Pagination from "react-js-pagination";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import fileDownload from "../../assets/img/filedownload.svg";
// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
  Modal,
  ModalBody,
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";

import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import DatePicker from "../../components/DatePicker/Datepicker.js";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import {
  AGENT_LIST,
  AGENT_CHAT_LIST,
  AGENT_CHAT_HISTORY,
  RE_CHAT
} from "../../constants";
import axios from "axios";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { useState, useEffect } from "react";
import { useHistory  } from "react-router-dom";

const BotReports = (props) => {
  const history = useHistory();
  let userobj = localStorage.getItem("user");

  let user = JSON.parse(userobj);
  const [agntNm, setAgntNm] = useState([]);
  const [cagntNm, setCAgntNm] = useState([]);
  const [showList, setShowList] = useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [showHistory, setShowHistory] = useState(false);
  const [search, setSearch] = useState({
    name: "",
    fromdate: "",
    id: user.user_id,
    userName: "",
  });
  const [isLoading, setIsLoading] = React.useState(false);

  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });
  const [userList, setUserList] = useState([]);
  const [chatHistory, setChatHistory] = useState([]);
  const [userListClne, setUserListClne] = useState([]);

  useEffect(() => {
    getAgentNames();
  }, []);
  const getAgentNames = async () => {
    await axios
      .get(AGENT_LIST)
      .then((res) => {
        setAgntNm(res.data.message);
        setCAgntNm(res.data.message);
      })
      .catch((err) => console.log("error===>", err));
  };

  const changeName = (e) => {
    let cmpgnname = e.target.value;

    cmpgnname ? setShowList(true) : setShowList(false);

    let namesLiist = cagntNm.filter((item, index) =>
      item.username.toLowerCase().includes(cmpgnname.toLowerCase())
    );
    setAgntNm(namesLiist);

    setSearch({
      ...search,
      name: cmpgnname,
    });
  };

  const getChatHistory = async (mobile, date, agent) => {
    let payload = {
      msisdn: mobile,
      date: date,
      agent_id: agent,
    };
    await axios
      .post(AGENT_CHAT_HISTORY, payload)
      .then((res) => {
        setChatHistory(res.data.message);
      })
      .catch((err) => console.log("error===>", err));

    setShowHistory(true);
  };

  const submitHandler = (page) => {
    setIsLoading(true)
    setCurrentPage(page);
    let fromdate = "";
    if (search.fromdate) {
      fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    } else {
      fromdate = "";
    }

    const agent = document.getElementById("agent").value;
    if (agent) {
      axios
        .get(
          AGENT_CHAT_LIST +
            `?agntname=${search.id}&date=${fromdate || ""}&page=${page}`
        )
        .then((res) => {
          setUserList(res.data);
          setUserListClne(res.data);
          setIsLoading(false)
        })
        .catch((err) => console.log("error===>", err));
    }
  };

  //Chat History

  const downloadChat = async (mobile, date, agent) => {
    let payload = {
      msisdn: mobile,
      date: date,
      agent_id: agent,
    };
    await axios
      .post(AGENT_CHAT_HISTORY, payload)
      .then((res) => {
        const body =
          res.data.message.length > 0 ? res.data.message : "No Records";
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        let jonbdy = [];
        body.map((item) => {
          var frmmsg = "";
          var tomsg = "";
          if (item.from_msg == 0) {
            tomsg = item.message_body;
           
          } else {
            frmmsg = item.message_body;
           
          }
          jonbdy.push({
            "message from User": tomsg,
            "message from Agent": frmmsg,
            time: item?.time,
          });
        });

        const ws = XLSX.utils.json_to_sheet(jonbdy);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, mobile + fileExtension);
      })
      .catch((err) => console.log("error====>", err));
  };

  const filteruser = (val) => {
    const filterobj = userListClne?.message?.filter(
      (item) =>
        item.User_Name.toLowerCase().includes(val.toLowerCase()) ||
        item.date.toLowerCase().includes(val.toLowerCase())
    );
    setUserList({
      message: filterobj,
    });
  };

  //go to chat 
  const gotoChat=async (userinfo)=>{
    console.log("-3-1--",user);
  //  await get();
  axios.post(RE_CHAT,{agent_id:userinfo?.agent_id,msisdn:userinfo?.msisdn,sender_id:user?.sender_id,agent_type:user.agenttype,user:userinfo?.User_Name}).then(res=>{

   let usrobjlocl = localStorage.getItem("userObj");
 
     let lclArr = [];
     let usrArr = JSON.parse(usrobjlocl);
     usrArr?.map((item) => lclArr.push(item));
     const filtered = lclArr.filter(
      user  => user.msisdn.includes(userinfo?.msisdn)
    );
    console.log("---224-->",filtered);
    console.log("---4-->",userinfo?.msisdn);
    console.log("---lclArr-->",lclArr);

    filtered?.length==0&&lclArr.push({
      "msisdn":userinfo?.msisdn,"name":userinfo?.User_Name
     })
     localStorage.removeItem("userObj");
    
     localStorage.setItem("userObj", JSON.stringify(lclArr));
       history.push("/admin/agent/liveChat");
  })
  .catch((err) => console.log("error===>", err));

  }

  return (
    <>
      <div className="content pb-0">
      <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
        {/* Chat History */}
        <Modal isOpen={showHistory} className="roles-popup">
          <div
            className="modal-header justify-content-center"
            style={{ backgroundColor: " rgba(233, 233, 233, 0.9294117647)" }}
          >
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setShowHistory(false)}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h3 className="title title-up multicolortext">
              Chat Histoty of{" "}
              {moment(chatHistory[0]?.time).format("DD-MM-YYYY")}
            </h3>
          </div>
          <ModalBody className="modelbody">
            <div className="chatBody">
              <div className="userinfo">
                <p>User: {search.userName}</p>

                <p>Agent: {document?.getElementById("agent")?.value}</p>
              </div>

              {chatHistory?.length > 0 ? (
                chatHistory?.map((item, key) => {
                  return (
                    <>
                      {item?.to_msg != 0 ? (
                        <Row>
                          <Col md="5" sm="12" className="mt-2">
                            {" "}
                            <div className="messageto">
                              <div className="messageContent">
                                {item.message_body.includes("/files/") ? (
                                  item.message_body.includes(".mp4") ||
                                  item.message_body.includes(".txt") ||
                                  item.message_body.includes(".pdf") ||
                                  item.message_body.includes(".xlsx")||
                                  item.message_body.includes(".vnd.") ? (
                                    <>
                                    <a href={item.message_body} target="_blank">
                                      <img
                                        src={fileDownload}
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                        }}
                                      />
                                     
                                    </a>
                                     <div style={{justifyContent:"space-between",display:"flex",width:"150px"}}>
                                     <span style={{ fontSize: "12px",color:"white" }}>
                                       ...{item?.message_body
                                         ?.split("/files/")[1]
                                         .substr(-9, 9)}
                                     </span>
                                     <span style={{ fontSize: "12px",color:"white" }}>
                                         {moment(item?.time).format(
                                           " hh:mm A"
                                         )}
                                       </span>
                                       </div>
                                       </>
                                  ) : (
                                    <>
                                    <a href={item.message_body} target="_blank">
                                      <img
                                        src={item.message_body}
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                        }}
                                      />
                                    </a>
                                     <div style={{justifyContent:"space-between",display:"flex",width:"150px"}}>
                                     <span style={{ fontSize: "12px",color:"white" }}>
                                       ...{item?.message_body
                                         ?.split("/files/")[1]
                                         .substr(-9, 9)}
                                     </span>
                                     <span style={{ fontSize: "12px",color:"white" }}>
                                         {moment(item?.time).format(
                                           " hh:mm A"
                                         )}
                                       </span>
                                       </div>
                                       </>
                                  )
                                ) : (
                                  <>
                                    <p>{item.message_body}</p>
                                    <div style={{ fontSize: "12px" }}>
                                      {moment(item?.time).format("hh:mm A")}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col md="7" sm="12" className="mt-2"></Col>
                        </Row>
                      ) : (
                        <Row>
                          <Col md="7" sm="12" className="mt-2"></Col>
                          <Col md="5" sm="12" className="mt-2">
                            <div className="messagefrom">
                              <div className="messageContent">
                                {item.message_body.includes("/files/") ? (
                                  item.message_body.includes(".mp4") ||
                                  item.message_body.includes(".txt") ||
                                  item.message_body.includes(".pdf") ||
                                  item.message_body.includes(".xlsx") ||
                                  item.message_body.includes(".vnd.") ? (
                                    <>
                                      <a
                                        href={item.message_body}
                                        target="_blank"
                                      >
                                        <img
                                          src={fileDownload}
                                          style={{
                                            height: "100px",
                                            width: "100px",
                                          }}
                                        />

                                       
                                      </a>
                                      <div style={{justifyContent:"space-between",display:"flex",width:"150px"}}>
                                      <span style={{ fontSize: "12px",color:"white" }}>
                                        ...{item?.message_body
                                          ?.split("/files/")[1]
                                          .substr(-9, 9)}
                                      </span>
                                      <span style={{ fontSize: "12px",color:"white" }}>
                                          {moment(item?.time).format(
                                            " hh:mm A"
                                          )}
                                        </span>
                                        </div>
                                    </>
                                  ) : (
                                    <>
                                      <a
                                        href={item.message_body}
                                        target="_blank"
                                      >
                                        <img
                                          src={item.message_body}
                                          style={{
                                            height: "100px",
                                            width: "100px",
                                          }}
                                        />
                                      </a>
                                      <div style={{justifyContent:"space-between",display:"flex",width:"150px"}}>
                                      <span style={{ fontSize: "12px",color:"white" }}>
                                        ...{item?.message_body
                                          ?.split("/files/")[1]
                                          .substr(-9, 9)}
                                      </span>
                                      <p style={{ fontSize: "12px",color:"white",marginRight:"10px" }}>
                                          {moment(item?.time).format(
                                            " hh:mm A"
                                          )}
                                        </p>
                                        </div>
                                   
                                    </>
                                  )
                                ) : (
                                  <>
                                    <p>{item.message_body}</p>
                                    <div
                                      style={{
                                        color: "white",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <span>
                                        {moment(item?.time).format("hh:mm A")}
                                      </span>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </>
                  );
                })
              ) : (
                <p>Not Found</p>
              )}
            </div>
          </ModalBody>
        </Modal>
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                <Row>
                  {(user?.role === "admin"||user?.role === "tdradmin") ? (
                    <Col md="3" sm="12" className="mt-4">
                      <MDBInput
                        label="name"
                        type="text"
                        id="agent"
                        value={search.name}
                        onChange={(e) => {
                          changeName(e);
                        }}
                      />

                      <ul className="searchScroll">
                        {showList &&
                          agntNm?.map((suggestion, index) => (
                            <li
                              key={index}
                              onClick={() => {
                                setSearch({
                                  ...search,
                                  name: suggestion.username,
                                  id: suggestion.id,
                                });
                                setShowList(false);
                                setValidate({
                                  message: "",
                                  notValid: false,
                                });
                              }}
                            >
                              {suggestion.username}
                            </li>
                          ))}
                      </ul>
                    </Col>
                  ) : (
                    <Col md="3" sm="12">
                      <p className="category"> Agent</p>
                      <Input
                        type="text"
                        placeholder="Campaign Name"
                        id="agent"
                        value={user.username}
                      />
                    </Col>
                  )}
                  <Col md="3" sm="12">
                    <p className="category"> Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                        setValidate({
                          message: "",
                          notValid: false,
                        });
                      }}
                    />
                  </Col>
                  <Col md="3" sm="6">
                    <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => submitHandler(currentPage)}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltipsubmit"
                    >
                      Submit
                    </UncontrolledTooltip>
                  </Col>

                  <Col md="2" sm="12" className="mt-4">
                    <MDBInput
                      label="Search"
                      type="text"
                      onChange={(e) => filteruser(e.target.value)}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
              <CardBody className="mb-0">
                <TableContainer component={Paper} style={{"height":"65vh"}}>
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th>S no </th>
                        <th> Date</th>
                        <th>User </th>
                        <th> Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userList?.message?.length > 0 ? (
                        userList?.message?.map((row, index) => (
                          <tr
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <td component="th" scope="row">
                              {index + 1}
                            </td>
                            <td>{row.date}</td>
                            <td>{row.User_Name}</td>

                            <td>
                              <a
                                to=""
                                target="_blank"
                                onClick={() => {
                                  getChatHistory(
                                    row.msisdn,
                                    row.date,
                                    row.agent_id
                                  );
                                  setSearch({
                                    ...search,
                                    userName: row.User_Name,
                                  });
                                }}
                                className="text-info mr-2"
                              >
                                <i className="tim-icons icon-chat-33"></i>
                              </a>
                              <a
                                to=""
                                target="_blank"
                                onClick={() =>
                                  downloadChat(
                                    row.msisdn,
                                    row.date,
                                    row.agent_id
                                  )
                                }
                                className="text-info mr-2"
                              >
                                <i className="tim-icons icon-cloud-download-93"></i>
                              </a>
                              {/* <a
                                 to=""
                                //href="/admin/agent/liveChat"
                                onClick={() =>
                                  gotoChat(
                                    row
                                  )
                                }
                                className="text-info mr-2"
                              >
                                <i className="tim-icons icon-cloud-download-93"></i>
                              </a> */}

                              <Button
                      color="secondary "
                     
                     
                      type="button"
                      onClick={() => gotoChat(row)}
                    >
                      Chat
                    </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <>
                          <tr>
                            <td colSpan={4}>No Records Found</td>
                          </tr>
                        </>
                      )}
                      
                    </tbody>
                    
                  </Table>
               
                </TableContainer>
                {userList?.numOfPages > 1 && (
          <div style={{ width: "30%", float: "right", padding: "8px" }}>
            <ResponsivePagination
              current={currentPage}
              total={userList?.numOfPages}
              onPageChange={(newPage) => {
                submitHandler(newPage);
              }}
            />
          </div>
        )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        
      </div>
    </>
  );
};

export default BotReports;
